import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {resetAllCandidatesInfo} from '/redux/action/candidate.action';
import {AllCandidatesReduxKeys, resetReport} from '/redux/action/report.action';

import {AllCandidatesReport} from './AllCandidatesReport';

export default connect(
  createStructuredSelector({}),

  dispatch => ({
    resetReport: ({reportKey}) =>
      dispatch(resetReport({reportKey, data: null})),
    resetAllCandidatesInfo: () => dispatch(resetAllCandidatesInfo()),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      resetCandidatesData: () => {
        dispatchProps.resetAllCandidatesInfo();
        AllCandidatesReduxKeys.forEach(element => {
          dispatchProps.resetReport({
            reportKey: element,
          });
        });
      },
    };
  },
)(AllCandidatesReport);
